export function titleCase(str) {
    return [ // Uppercase words
        'Id', 
        'Tv', 
        'LLC',
        'Tag',
        '[a-z]{1}'
    ].reduce(
        (ns, upper) => ns.replace(new RegExp('\\b' + upper + '\\b', 'ig'), (m,loc,orig) => {
            return orig[loc-1] === "'" ? m : m.toUpperCase();
        } ),
    [ 		// Lowercase words
        'A', 
        'An', 
        'The', 
        'And', 
        'But', 
        'For', 
        'Nor', 
        'At',
        'By', 
        'For', 
        'From', 
        'Into', 
        'Near', 
        'Of', 
        'Du', 
        'En',
        'Et',
        'On', 
        'Onto', 
        'To', 
        'With'
    ].reduce( 
        (ns, lower) => ns.replace(new RegExp('\\s' + lower + '\\s', 'ig'), (txt) => txt.toLowerCase()), 
        str.replace(/([^\W_]+[^\s-\/]*) */g, (txt) => txt.length > 2 ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() : txt )
    ));
}